import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const MemberContext = createContext(null);

export function MemberProvider({ children }) {
  const [member, setMember] = useState(null); // null=checking, false=anon, obj=signed-in
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    // If landing from OAuth callback, skip /me — the callback handler will run first
    if (
      typeof window !== "undefined" &&
      window.location.hash &&
      window.location.hash.includes("session_id=")
    ) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/members/me");
      setMember(data);
    } catch {
      setMember(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/my-account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const signOut = async () => {
    try {
      await api.post("/members/logout");
    } catch {
      /* ignore */
    }
    setMember(false);
  };

  return (
    <MemberContext.Provider value={{ member, loading, signIn, signOut, refresh: check, setMember }}>
      {children}
    </MemberContext.Provider>
  );
}

export function useMember() {
  const ctx = useContext(MemberContext);
  if (!ctx) throw new Error("useMember must be inside MemberProvider");
  return ctx;
}
